module.exports = __webpack_public_path__ + "img/Goal_1.ad01c834.png";